<template>
    <div class="notifications-data">
        <div class="summary">
            <h3>Notifications</h3>
            <div class="summary-details">
                <div class="total">
                    <div class="label"> Total notifications </div>
                    <div class="count">
                        {{ data.total }}
                    </div>
                </div>

                <div class="hcp-views">
                    <div class="hcp-main-label"> Views </div>
                    <div
                        v-for="(count, speciality) in specialityViews"
                        :key="speciality"
                        class="hcp-row"
                    >
                        <span class="hcp-label">{{ speciality }}</span>
                        <span class="hcp-value">{{ count }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="notifications">
            <table>
                <thead>
                    <tr>
                        <th>Title</th>
                        <th class="text-right"> Views </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="[title, item] in limitedNotificationsDetails"
                        :key="title"
                    >
                        <td>{{ title }}</td>
                        <td class="text-right">
                            {{ item.readOccurrences }} /
                            {{ item.totalOccurrences }}
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="showAllVisible" class="show-all" @click="openModal">
                Show all
            </div>
        </div>

        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-content">
                <div class="modal-header">
                    <h3>All Notifications</h3>
                    <button class="modal-close" @click="closeModal">×</button>
                </div>
                <div class="modal-body">
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th class="text-right">Views</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-for="[title, item] in notificationsDetails"
                                :key="title"
                            >
                                <td>{{ title }}</td>
                                <td class="text-right">
                                    {{ item.readOccurrences }} /
                                    {{ item.totalOccurrences }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: false,
            default: () => ({})
        }
    },

    computed: {
        specialityViews() {
            return {
                Doctors: this.data.doctorsViews || 0,
                Nurses: this.data.nursesViews || 0,
                Pharmacists: this.data.pharmacistsViews || 0,
                Nutritionists: this.data.nutritionistsViews || 0
            };
        },

        notificationsDetails() {
            if (!this.data.notificationsDetails) {
                return [];
            }

            return Object.entries(this.data.notificationsDetails);
        },

        limitedNotificationsDetails() {
            return this.notificationsDetails.slice(0, this.maxItems);
        },

        showAllVisible() {
            const details = this.data.notificationsDetails;
            return details && Object.entries(details).length > this.maxItems;
        }
    },

    data() {
        return {
            maxItems: 5,
            showModal: false
        };
    },

    methods: {
        openModal() {
            this.showModal = true;
            document.body.style.overflow = 'hidden';
        },

        closeModal() {
            this.showModal = false;
            document.body.style.overflow = '';
        }
    }
};
</script>
